import {
    NavLink
  } from "react-router-dom";
import {IconHome ,IconBandage , IconUsers , IconFriends, IconCalendarTime, IconNewSection, IconBellRinging, IconWallet, IconInfoCircleFilled, IconInfoCircle } from '@tabler/icons-react';
import { useEffect,useState,useCallback } from "react";

const Footer = () => {
    const mhsnav = [
        {
            name:'Home',
            link:'/patient/dashboard',
            icon:<IconHome size={25}/>
        },
        {
            name:'New Request',
            link:'/patient/form',
            icon:<IconNewSection size={25}/>
        },
        {
            name:'Payment Info',
            link:'/patient/payment',
            icon:<IconWallet size={25}/>
        },
        {
            name:'Notifications',
            link:'/patient/notifications',
            icon:<IconBellRinging size={25}/>
        },
        {
            name:'Help',
            link:'/patient/info',
            icon:<IconInfoCircle size={25}/>
        }
    ]

    return (
         (
            <div className={`flex justify-around fixed bottom-0 w-full shadow-md py-1 pt-3 text-mhs-secondary text-xs`} style={{background: 'linear-gradient(180deg, #FFF5E1 0%, #FDE7B7 60%)',zIndex:11}}>
                {mhsnav.map((navDetails) => (
                    
                    <NavLink
                        key={navDetails.link}
                        className={({ isActive }) =>
                            isActive ? 'nav-btn active' : 'nav-btn'
                        }
                        to={navDetails.link}
                    >
                        <div className="flex flex-col justify-center items-center">
                            <span className="nav-icon font-extrabold !text-xl">{navDetails.icon}</span>
                            <span>{navDetails.name}</span>
                        </div>
                    </NavLink>
                ))}
            </div>
        )
    );
};

export default Footer;
